import React from 'react';
import { Grid } from '@material-ui/core';
import { SearchResult } from '../../../types/api';
import Paper from '../../../elements/Paper';
import { getMrns } from '../../../utils/AccountDetailsUtil';
import { CardType } from '../../../types/cardTypes';

type LinkedRecordComponentProps = {
    openRemovalModal: any;
    linkedRecord: SearchResult;
    verifiedWith: string;
};

function LinkedRecordComponent({ linkedRecord, openRemovalModal, verifiedWith }: LinkedRecordComponentProps) {
    return (
        <>
            <Grid
                container
                direction='row'
                style={{ width: '460px' }}
            >
                <Paper
                    variant='outlined'
                    cardType={CardType.LinkedCard}
                    onUnlink={openRemovalModal}
                    inputData={linkedRecord}
                    verifiedWith={verifiedWith}
                    mrns={getMrns([linkedRecord])}
                />
            </Grid>
        </>
    );
}

export default LinkedRecordComponent;
